import ResponsiveDrawer from './ResponsiveDrawer';

export default function Error404(){
    return(
        <ResponsiveDrawer>
            <h2>Página não encontrada.</h2>
        </ResponsiveDrawer>
    )
}